import {
  useContext,
  useEffect,
  useState,
} from 'react';

import {
  Outlet,
  useLocation,
  useNavigate,
} from 'react-router-dom';

import {
  BrandingContext,
  LayoutContext,
  SessionContext,
} from '../libs/contexts.js';
import {
  getFields,
  qualify,
  validateScreenFields,
} from '../libs/workflow.js';
import { UiLayoutPlaceholder } from './placeholders.jsx';

export const Page = () => {

    const navigate = useNavigate();
    let location = useLocation();

    const { layout, setLayout } = useContext(LayoutContext);
    const { session, setSession } = useContext(SessionContext);
    const { branding } = useContext(BrandingContext);
    const [lastValidationUpdate, setLastValidationUpdate] = useState(false);


    useEffect(() => {

        if (session.term_selected) {
            if (session.term_selected.includes("10") || session.term_selected.includes("20")) {
                let termValue = session.term_selected.replace(/\D/g, '');
                setSession({ term: termValue.toString() });
                console.info("Setting term to match term_selected");
            }
        }

    }, [session.term_selected]);


    useEffect(() => {

        if (layout.currentScreen) {
            if (['beneficiary', 'payment', 'consent', 'policy'].includes(layout.currentScreen) && ['unqualified', 'mismatch'].includes(layout.disqualified)) {
                let paths = {
                    unqualified: '/ineligible',
                    mismatch: '/ineligible'
                };
                setSession({ ineligible_reasons: layout.disqualified_reason });
                navigate(paths[layout.disqualified]);
            } else {
                if ('ineligible' !== layout.currentScreen) {

                    setLayout({
                        fields: getFields({ screen: layout.currentScreen })
                    });
                }
            }
        }

    }, [layout.currentScreen, layout.disqualified]);



    useEffect(() => {


        if (lastValidationUpdate) {
            /*
            setLayout({
                fields: lastValidationUpdate
            });
            */
        }

    }, [lastValidationUpdate]);


    useEffect(() => {
        const navEntry = window.performance.getEntriesByType('navigation')[0];
        const navType = navEntry?.type;

        const isRefresh = navType === 'reload';
        const isBackOrForward = navType === 'back_forward';
        const isFromNavigate = sessionStorage.getItem('fromNavigate') === true;

        sessionStorage.removeItem('fromNavigate');
        const isResumePage = /^\/resume\/[^/]+$/.test(location.pathname);

        if (!isFromNavigate && !isBackOrForward && !isResumePage && (navType === 'navigate' || isRefresh)) {
            navigate('/', { replace: true });
        }
        

    }, []);

    useEffect(() => {
        if (undefined !== layout.currentScreen && session.quote) {

            let validation = validateScreenFields({ screen: layout.currentScreen, session: session });

            setLayout({
                validation: validation
            });

            let allFields = [];

            if (validation && validation.valid && validation.valid.length > 0) {
                allFields = allFields.concat(validation.valid);
            }
            if (validation && validation.invalid && validation.invalid.length > 0) {
                allFields = allFields.concat(validation.invalid);
            }


            if (undefined === layout.fields || 0 === Object.keys(layout.fields).length) {
                //onsole.info("We don't have fields", layout.currentScreen, layout);
                let newFields = {};
                if (allFields) {
                    for (let field of allFields) {
                        newFields[field] = "unknown";
                    }
                }
                setLayout(
                    { fields: newFields }
                );
            } else {
                //onsole.info("We have some fields", layout.fields);
                let newFields = {};
                let missing = false;
                let errors = false;
                for (let field of Object.keys(layout.fields)) {
                    let found = false;
                    if (validation.invalid && validation.invalid.includes(field)) {

                        if (layout.lastValidated && layout.lastValidated === layout.currentScreen) {
                            newFields[field] = "error";
                        } else {
                            newFields[field] = "unknown";
                        }

                        found = true;
                        errors = true;
                    } else {
                        if (validation.valid && validation.valid.includes(field)) {
                            newFields[field] = "ok";
                            found = true;
                        }
                    }
                    if (!found) {
                        missing = true;
                        //onsole.info("Missing", field);
                    }
                }

                if (JSON.stringify(layout.fields) !== JSON.stringify(newFields)) {
                    //todo check if we can remove this entirely                    
                    setLastValidationUpdate(newFields);
                }



                if (layout.fields && Object.keys(layout.fields).length > 0 && !missing) {
                    //onsole.info("New val", layout.lastValidated, errors);
                    if (errors) {
                        if (layout.lastValidated && layout.lastValidated === layout.currentScreen) {
                            setLayout({
                                screenReady: !errors
                            });
                        }
                    } else {
                        setLayout({
                            screenReady: !errors
                        });
                        if (!errors) {
                            setLayout({
                                lastValidated: layout.currentScreen
                            });
                        }
                    }
                } else {
                    //onsole.info("Cannot validate", layout.fields, missing);
                }

            }

            let qualification = qualify({ session: session, licensing: layout.licensing });
            if (qualification && qualification.disqualified) {
                setLayout({ disqualified: qualification.unhappyPath, disqualified_reason: qualification.reasons });
            } else if (!layout.disqualified_reason || !layout.disqualified_reason.includes('geo_province_not_licensed')) {
                setLayout({ disqualified: false, disqualified_reason: [] });
            }
            //onsole.info("Qualification", qualification);

        }

    }, [layout.currentScreen, layout.fields, layout.lastValidated, session]);

    useEffect(() => {
        setSession({ latest_step: layout.currentScreen });
    }, [location.pathname, layout.currentScreen, session.jump_entry, session.quote]);

    return (
        <>
            {layout.name &&
                <UiLayoutPlaceholder MyOutlet={Outlet} layoutName={layout.name} />
            }
        </>
    )

}

